import type { ITheme } from '@visactor/vchart';
import { semiDesignLight } from '@visactor/vchart-semi-theme';

export const ttPlatformLight: ITheme = {
  ...semiDesignLight,
  name: 'ttPlatformLight',
  description: 'TT Platform - light',
  type: 'light'
};
